module.exports = __webpack_public_path__ + "static/media/homemarket.3c7ac999.png";